import Text from '../../graphics/Text';
import DraggablePreset from './DraggablePreset';
import { getCenterX, getCenterY } from '../../utils/CoordinateCalculator';

/**
 * Text simply cuts in and out - no animation
 */
export default class Cut extends DraggablePreset {
  constructor(app) {
    super(app);
    this.text = new Text(app);

    this.container.addChild(this.text);
  }

  update(model) {
    super.update(model);

    // update content and size
    this.text.text = model.text;
    this.text.updateStyle(model);

    this.setDraggableRoot(
      this.text.innerControls.height,
      this.text.innerControls.width
    );

    // position
    this.text.innerControls.x = getCenterX(this.text.innerControls, this.root);
    this.text.innerControls.y = getCenterY(this.text.innerControls, this.root);
  }
}
